module.exports = __webpack_public_path__ + "static/media/who-logo.73b2126d.png";